import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'title', 'actionContainer'];
var baseStyle = {
  container: {
    py: 5,
    flexDirection: {
      base: 'column',
      md: 'row'
    }
  },
  title: {
    mr: {
      base: 0,
      md: 0
    },
    fontWeight: '700',
    fontSize: 'lg'
  }
};
function variantInline() {
  return {
    title: {
      fontWeight: 'normal',
      fontSize: 'md'
    },
    actionContainer: {
      ml: 2,
      a: {
        fontWeight: 'bold'
      }
    }
  };
}
var variants = {
  inline: variantInline
};
var defaultProps = {};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  variants,
  defaultProps
});